// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"6bf2dad1","260":"85eabad6","450":"60b1d05a","511":"e57ae850","905":"e4d0b568"}[chunkId] + ".chunk.js";
};